export const FIELD_IS_REQUIRED = 'This field is required';

export const getMinLengthErrorMessage = (limitValue: number) => `Min. length is ${limitValue} symbols`;
